import { render, staticRenderFns } from "./EditReferentiel.vue?vue&type=template&id=21bebb4c"
import script from "./EditReferentiel.vue?vue&type=script&lang=js"
export * from "./EditReferentiel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports